import * as React from "react";
import * as DialogPrimitive from "@radix-ui/react-dialog";
import { cn } from "../lib/cn";
import { DialogTitle } from "./dialog";

const CommandDialogOverlay = React.forwardRef<
  React.ElementRef<typeof DialogPrimitive.Overlay>,
  React.ComponentPropsWithoutRef<typeof DialogPrimitive.Overlay>
>(({ className, ...props }, ref) => (
  <DialogPrimitive.Overlay
    ref={ref}
    className={cn("fixed inset-0 z-50 bg-black/60 backdrop-blur-sm", className)}
    {...props}
  />
));
CommandDialogOverlay.displayName = DialogPrimitive.Overlay.displayName;

const CommandDialogContent = React.forwardRef<
  React.ElementRef<typeof DialogPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof DialogPrimitive.Content>
>(({ className, children, ...props }, ref) => (
  <DialogPrimitive.Portal>
    <CommandDialogOverlay />
    <DialogPrimitive.Content
      ref={ref}
      className={cn(
        "fixed left-[50%] top-[20%] z-50 grid w-full max-w-2xl translate-x-[-50%] gap-0 border border-[var(--color-border)] dark:border-[var(--color-border)] bg-white dark:bg-neutral-900 shadow-2xl rounded-lg overflow-hidden",
        className,
      )}
      {...props}
    >
      <DialogTitle className="sr-only">Command palette</DialogTitle>
      {children}
    </DialogPrimitive.Content>
  </DialogPrimitive.Portal>
));
CommandDialogContent.displayName = DialogPrimitive.Content.displayName;

export { CommandDialogContent };
